import { Box } from "app/components/common";
import React from "react";
import RecordMediaBlock from "../../Record/Record.web";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";

interface IVideoAnalysis {}

const VideoAnalysis = ({}: IVideoAnalysis) => {
  return (
    <Box
      flex={1}
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      width="100%"
      alignSelf="center"
      maxWidth={isWebDesktop ? "25vw" : undefined}
    >
      <RecordMediaBlock onSubmit={() => null} recordType="camera" />
    </Box>
  );
};

export default VideoAnalysis;
